import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedContent } from '../../../lib/features/auth/components/ProtectedContent';
import { Role } from '../../../lib/features/auth/model/Role';
import { AddContractPage } from './client_contracts/page/AddContractPage';
import { UpdateContractPage } from './client_contracts/page/UpdateContractPage';

import { AddPartnerConfigPage } from './pages/AddPartnerConfigPage';
import { UpdatePartnerConfigPage } from './pages/UpdatePartnerConfigPage';
import { PartnerListPage } from './pages/PartnerListPage';

export const PlatformPartnersRoutes: FC = () => (
	<ProtectedContent {...{ roles: [Role.Admin, Role.PlatformAdmin, Role.PlatformPartners] }}>
		<Routes>
			<Route {...{ path: ':id/contratos/novo', element: <AddContractPage /> }} />
			<Route {...{ path: ':id/contratos/:c_number', element: <UpdateContractPage /> }} />
			<Route {...{ path: 'novo', element: <AddPartnerConfigPage /> }} />
			<Route {...{ path: ':id', element: <UpdatePartnerConfigPage /> }} />
			<Route {...{ path: '/', element: <PartnerListPage /> }} />
		</Routes>
	</ProtectedContent>
);
